webpackJsonp([73],{

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1261);


/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(171);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(785);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1260]);


// WEBPACK FOOTER //
// app/datetime.pt-f81cb4f16146eec4039b.js